<template>
  <div class="agent-layer">
    <el-container class="page-container">
      <el-aside class="menu-aside" width="200px">
        <h2 class="system-title">
          <img class="system-logo" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/logo_ddt_1%402x.png" alt="logo" />
          <span>{{ $t('followOrder.text1') }}</span>
        </h2>
        <el-menu ref="menuRef" :default-active="currentPath" router>
          <el-sub-menu index="1">
            <template #title>
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_home%402x.png" alt="home" />
              <span>{{ $t('followOrder.text2') }}</span>
            </template>
            <el-menu-item index="account">
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_acc%402x.png" alt="account" />
              <span>{{ $t('followOrder.text3') }}</span>
            </el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="2">
            <template #title>
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_kehuguanli%402x.png" alt="customermanage" />
              <span>{{ $t('followOrder.text28') }}</span>
            </template>
            <el-menu-item index="position">
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_kehuguanli%402x.png" alt="customerlist" />
              <span>{{ $t('followOrder.text29') }}</span>
            </el-menu-item>
            <el-menu-item index="traderecord">
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_kehuliebiao%402x.png" alt="accountlist" />
              <span>{{ $t('followOrder.text57') }}</span>
            </el-menu-item>
            <el-menu-item index="subscriberecord">
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_churujinliebiao%402x.png" alt="withdrawdeposit" />
              <span>{{ $t('followOrder.text70') }}</span>
            </el-menu-item>
            <el-menu-item index="incomedetail">
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_churujinliebiao%402x.png" alt="withdrawdeposit" />
              <span>{{ $t('followOrder.text133') }}</span>
            </el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="3">
            <template #title>
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_dailiguanli%402x.png" alt="agentmanage" />
              <span>{{ $t('followOrder.text101') }}</span>
            </template>
            <el-menu-item index="withdrawrecord">
              <img class="menu-icon" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_daililiebiao%402x.png" alt="agentlist" />
              <span>{{ $t('followOrder.text102') }}</span>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="agent-header">
          <div class="header-left">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item
                v-for="(item, index) in breadcrumbList"
                :key="index"
                :to="item.link ? { path: item.link } : null"
              >
                <router-link v-if="item.link" :to="item.link">{{ item.text }}</router-link>
                <span v-else>{{ item.text }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="header-right">
            <el-dropdown @command="accountChangeHandler">
              <div class="el-dropdown-link">
                <img class="mr-8" style="width: 20px;height: 20px;" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_account%402x.png" />
                <span class="mr-8">{{ userName || '' }}</span>
                <img style="width: 10px;height: 6px;" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_more%402x.png" />
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-if="openCRM" command="web">
                    <img style="width: 12px;height: 12px;margin-right: 6px;" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_account_web%402x.png" />
                    <span>{{ $t('proxy.text39') }}</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="isProxyAdmin" command="agent">
                    <img style="width: 12px;height: 12px;margin-right: 6px;" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_jiaoyiyuan%402x.png" />
                    <span>{{ $t('proxy.text195')}}</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="logout">
                    <img style="width: 12px;height: 12px;margin-right: 6px;" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_account_out%402x.png" />
                    <span>{{ $t('proxy.text256')}}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <el-dropdown>
              <div class="el-dropdown-link">
                <span class="mr-8">{{ langDisplay }}</span>
                <img style="width: 10px; height: 6px;" src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_more%402x.png" />
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="ChangeLang('cn')">简体中文</el-dropdown-item>
                  <el-dropdown-item @click="ChangeLang('en')">English</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <!-- 服务器选择 -->
            <el-dropdown v-if=currentServer?.name>
              <div class="el-dropdown-link">
                <span>{{ currentServer?.name }}</span>
                <img
                  class="dropdown-icon"
                  src="http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/icon_more%402x.png"
                  alt="下拉"
                />
              </div>
              <template #dropdown>
                <el-dropdown-menu class="server-dropdown">
                  <!-- 使用 el-radio-group -->
                  <el-radio-group v-model="selectedServerName" @change="changeServer">
                    <el-dropdown-item
                      v-for="server in serverList"
                      :key="server.name"
                    >
                      <div class="server-radio-content">
                        <el-radio :value="server.name">
                    
                        <div class="server-name-wrapper">
                          <span class="server-name">{{ server.name }}</span>
                        </div>
                        </el-radio>
                        <div class="server-latency">
                          {{ server.latency || "..." }} ms
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-radio-group>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="page-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import apiService from '@/api/request';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import {
  ElContainer,
  ElAside,
  ElHeader,
  ElMain,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElMessage,
} from 'element-plus'
import { setSelectedServer, fetchServerList, loadCachedServerList, getSelectedServer } from '@/api/http';

const router = useRouter();
const route = useRoute();
const userName = ref('  ');
const store = useStore();
const { t, locale } = useI18n();
const langDisplay = ref(store.getters.getNowTheme.lang === 'en' ? 'English' : '简体中文');
const isProxyAdmin = ref(false);
const openCRM = ref(false);
const activeMenu = ref(route.path); // 初始化时设置为当前路径
const currentPath = ref(route.query.activeMenu || route.fullPath);
const menuRef = ref(null);

// 服务器列表和选中服务器
const serverList = ref([]); // 服务器列表
const selectedServerName = ref(""); // 当前选中服务器的名字
const currentServer = ref({}); // 当前选中服务器

const menuPathMap = {
  followorder: "/followorder",
  account: "/followorder/account",
  position: "/followorder/position",
  traderecord: "/followorder/traderecord",
  subscriberecord: "/followorder/subscriberecord",
  incomedetail: "/followorder/incomedetail",
  withdrawrecord: "/followorder/withdrawrecord",
};

// 切换语言函数
const ChangeLang = (newLang) => {
  langDisplay.value = newLang === 'cn' ? '简体中文' : 'English';
  locale.value = newLang;
  store.commit('NOW_LANG', newLang);
  localStorage.setItem('lang', newLang);
  window.location.reload();
};

// 切换服务器
const changeServer = (selectedName) => {
  const selectedServer = serverList.value.find((server) => server.name === selectedName);
  if (selectedServer) {
    currentServer.value = selectedServer;
    selectedServerName.value = selectedName;
    setSelectedServer(selectedServer);
  }
};

// 获取服务器列表
const loadServersFromCache = async () => {
  const storedServer = await getSelectedServer();
  serverList.value = await loadCachedServerList();
  if (!storedServer || !storedServer.name) {
    // 如果没有选中的服务器，则设置默认服务器为第一个
    const defaultServer = serverList.value[0];
    currentServer.value = defaultServer;
    selectedServerName.value = defaultServer.name;
    setSelectedServer(defaultServer);
  } else {
    currentServer.value = storedServer;
    selectedServerName.value = storedServer.name;
  }
};

// 获取个人信息
const fetchUserInfo = () => {
  console.log('获取用户信息');
  apiService.UserInformation().then((response) => {
    const data = response.data;
    if (data) {
      userName.value = data.nickname || '';
      isProxyAdmin.value = (data.isProxyAdmin && data.hasProxyPermission) || false;
      openCRM.value = data.hasCrmPermission;
    }
  }).catch((error) => {
    console.error('获取用户信息失败', error);
  });
};

// 处理登出
const handleLogout = () => {
  apiService.Logout()
    .then((response) => {
      if (response.status === 1) {
        localStorage.clear();
        localStorage.setItem('lang', locale.value);
        store.commit('NOW_LANG', locale.value);
        router.push('/login');
      } else {
        console.error('登出失败:', response.message);
      }
    })
    .catch((error) => {
      console.error('登出请求错误:', error);
    });
};

// 根据用户操作判断是否登出
const accountChangeHandler = (cmd) => {
  if (cmd === 'web') {
    // 如果没有权限则弹出提示
    if (!openCRM.value) {
      ElMessage({
        message: t('signUp.text45'),
        type: 'error',
      })
      return;
    }
    router.push('/accountInformation/myAccount');
  } else if (cmd === 'agent' && isProxyAdmin.value) {
    router.push('/agent');
  } else if (cmd === 'logout') {
    handleLogout();
  }
};

const breadcrumbList = ref([]);

const generateBreadcrumbs = (path) => {
  const breadcrumbs = [];
  let currentRoute = router.resolve(path).route;
  while (currentRoute) {
    if (currentRoute.meta && currentRoute.meta.breadcrumb) {
      breadcrumbs.unshift({
        text: currentRoute.meta.breadcrumb,
        link: currentRoute.path !== path ? currentRoute.path : null, // 当前页不需要跳转链接
      });
    }
    currentRoute = currentRoute.parent || null; // 如果有 parent 信息，则继续往上查找
  }
  breadcrumbList.value = breadcrumbs;
};

// 动态生成面包屑
watch(
  () => route.path,
  () => {
    const breadcrumbs = [];

    route.matched.forEach((matchedRoute, routeIndex) => {
      const metaBreadcrumb = matchedRoute.meta?.breadcrumb;

      if (metaBreadcrumb) {
        const breadcrumb = Array.isArray(metaBreadcrumb)
          ? metaBreadcrumb // 如果是数组，直接加入
          : typeof metaBreadcrumb === "function"
          ? metaBreadcrumb(route) // 如果是函数，调用生成
          : [metaBreadcrumb]; // 否则视为字符串

        const parentLink = typeof matchedRoute.meta.parentLink === "function"
          ? matchedRoute.meta.parentLink(route)
          : matchedRoute.meta.parentLink;

        console.log('parentLink', parentLink);

        breadcrumb.forEach((key) => {

          // 获取父级路由,从meta中获取
          const link = parentLink ? parentLink : matchedRoute.path;
          breadcrumbs.push({
            text: t(key),
            // 仅最后一级不需要跳转，其余都生成对应链接
            link: routeIndex < route.matched.length ? link : null,
            activeMenu: matchedRoute.activeMenu,
          });
        });
      }
    });
    breadcrumbList.value = breadcrumbs;
  },
  { immediate: true }
);

// 监听路由变化以更新 activeMenu
watch(
  () => route.path,
  (newPath) => {
    const activeKey = Object.keys(menuPathMap).find(
      (key) => menuPathMap[key] === newPath
    );

    if (activeKey) {
      currentPath.value = activeKey;
      if (menuRef.value) {
        console.log('activeKey', activeKey);
        menuRef.value.activeIndex = activeKey; // 更新菜单高亮
      }
    }
  },
  { immediate: true }
);

onMounted(() => {

  if(route.path) {
    generateBreadcrumbs(route.path);
  }
  
  const matchedIndex = Object.keys(menuPathMap).find(
    (key) => menuPathMap[key] === route.path
  );
  console.log('matchedIndex', matchedIndex);
  if (matchedIndex) {
    activeMenu.value = matchedIndex;
    if (menuRef.value) {
      menuRef.value.activeIndex = matchedIndex;
    }
  }

  loadServersFromCache();

  locale.value = store.getters.getNowTheme.lang;
  fetchUserInfo();
});
</script>

<style lang="less" scoped>
.agent-layer {
  background-color: @bg-color;
}

/* 自定义选中状态样式 */
::v-deep .el-menu-item.is-active {
  background-color: #51B4F1 !important; /* 修改为需要的背景色 */
  color: #ffffff !important; /* 修改为需要的文字颜色 */
}

::v-deep .el-menu-item:hover {
  background-color: #66b1ff !important; /* 悬停样式 */
  color: #ffffff !important;
}

::v-deep .el-menu-item.is-active .menu-icon,
::v-deep .el-menu-item:hover .menu-icon {
  filter: brightness(0) invert(1); /* 图标颜色 */
}

.system-title {
  display: flex;
  align-items: center;
  .system-logo {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
}

.menu-aside {
  /* 移除固定宽度 */
  width: auto !important;

  .el-menu-item,
  .el-sub-menu {
    white-space: nowrap; /* 禁止换行 */
    width: auto !important; /* 允许宽度自适应内容 */
  }
}

.dropdown-icon {
  width: 10px;
  height: 6px;
  margin-left: 8px;
}

.server-item {
  padding: 10px 12px;
}

.server-name {
  flex: 1;
  font-size: 14px;
}

.el-radio__label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.el-radio {
  margin: 0;
  padding: 2px;
  border-radius: 4px;
}

.server-dropdown {
  max-width: 120px !important; /* 设置最大宽度 */
  width: auto; /* 自动调整宽度 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 超出显示省略号 */
  white-space: nowrap; /* 不换行 */
}

.server-radio-content {
  display: flex;
  flex-direction: column; /* 垂直布局 */
}

.server-name-wrapper {
  display: flex;
  align-items: center; /* el-radio 和第一行文本垂直居中对齐 */
}

.server-name {
  font-size: 14px; /* 文本大小 */
}

.server-latency {
  font-size: 12px; /* 文本大小 */
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  border: 1px solid #F2F4FB;
  color: #51B4F1;
  border-radius: 4px;
  padding: 4px 8px;
  height: 30px;
  margin-left: 24px;
}

</style>

